"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGameActions = useGameActions;
const react_1 = require("react");
const models_1 = require("@creature-chess/models");
const react_redux_1 = require("react-redux");
function useGameActions() {
    const dispatch = (0, react_redux_1.useDispatch)();
    return (0, react_1.useMemo)(() => ({
        buyXp: () => dispatch(models_1.PlayerActions.buyXpPlayerAction()),
        buyCard: (index) => dispatch(models_1.PlayerActions.buyCardPlayerAction({ index })),
        rerollCards: () => dispatch(models_1.PlayerActions.rerollCardsPlayerAction()),
        toggleShopLock: () => dispatch(models_1.PlayerActions.toggleShopLockPlayerAction()),
        sellPiece: (pieceId) => dispatch(models_1.PlayerActions.sellPiecePlayerAction({ pieceId })),
        readyUp: () => dispatch(models_1.PlayerActions.readyUpPlayerAction()),
        quitGame: () => dispatch(models_1.PlayerActions.quitGamePlayerAction()),
        spectate: (playerId) => dispatch(models_1.PlayerActions.spectatePlayerAction({ playerId })),
    }), [dispatch]);
}
